import { ReactNode } from 'react';
import { useElementFilter } from '@backstage/core-plugin-api';
import { Columns, Grid, Responsive, Text } from '@backstage/ui';

import styles from './ModernCardField.module.css';

export interface ModernCardFieldProps {
  label: string;
  value?: string;
  colSpan?: Responsive<Columns>;
  children?: ReactNode;
  hidden?: boolean;
}

export function ModernCardField(props: Readonly<ModernCardFieldProps>) {
  const { label, value, colSpan, children, hidden } = props;

  const childElements = useElementFilter(children, c => c.getElements());

  const content =
    childElements.length > 0 ? (
      childElements
    ) : (
      <Text as="p" weight="bold" className={styles.value}>
        {value ?? ''}
      </Text>
    );
  return (
    <Grid.Item colSpan={colSpan ?? 'auto'} hidden={hidden}>
      <Text
        as="h2"
        variant="body-x-small"
        weight="bold"
        color="secondary"
        className={styles.label}
        style={{ marginBottom: '8px' }}
      >
        {label}
      </Text>
      {content}
    </Grid.Item>
  );
}
